import { Injectable, EventEmitter } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {CryptoService} from './crypto.service';
import { BehaviorSubject } from 'rxjs';

export const STORE_KEY_selectDefaultMode = 'selectDefaultMode';
export const STORE_KEY_themeColorCode = 'themeColorCode';
export const STORE_KEY_logoPath = 'logoPath';
export const STORE_KEY_enableDomain = 'enableDoamin';
export const STORE_KEY_domainPtah = 'DomainPtah';
export const STORE_KEY_RegionIds = 'RegionIds';
export const STORE_KEY_SelectTab = 'SelectTab';
export const STORE_KEY_PaymentInfo = 'PaymentInfo';
export const STORE_KEY_BillingStatement = 'BillingStatement';


@Injectable({
  providedIn: 'root'
})
export class RegionService {

  constructor(private http: HttpClient, private cryptoService: CryptoService) { }
  public geteventEmitter: EventEmitter<any> = new EventEmitter<any>();
  private selectedRegionNameSubject = new BehaviorSubject<string>('');

  // setSelectedRegionName(hashId: string) {
  //   this.selectedRegionNameSubject.next(hashId);
  // }

  // getSelectedRegionName() {
  //   return this.selectedRegionNameSubject.asObservable();
  // }

  ReadRegion(otp): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/read/all`, {otp: otp});
  }

  AddRegion(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/add`, params);
  }

  UpdateRegion(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/update`, params);
  }

  DeleteRegion(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/delete`, params);
  }

  postFile(file: File, name: string): Observable<any> {
    const fileForm: FormData = new FormData();
    fileForm.append('name', name);
    fileForm.append('logo', file, file.name);
    return this.http.post<any>('/upload/logo', fileForm);
  }

  renameFile(oldName: string, newName: string): Observable<any> {
    const params = {
      oldName: oldName,
      newName: newName
    };
    return this.http.post<any>('/api/rename', params);
  }

  deleteFile(name: string): Observable<any> {
    const params = {
      name: name
    };
    return this.http.post<any>('/api/delete', params);
  }

  ReadPrivacyAndTerms(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/read/privacyandterms`, params);
  }

  UpdatePrivacy(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/region/update/privacy`, params);
  }

  UpdateTerms(params): Observable<any> {
    params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/region/update/terms`, params);
  }

  ReadCompanyMember(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/member/read`, params);
  }

  UpdateCompanyMember(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/member/update`, params);
  }

  ActivateCompanyMember(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/member/activate`, params);
  }

  CheckCompanyMember(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/member/check`, params);
  }

  ReadProCompany(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/read`, params);
  }

  AddProCompany(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/add`, params);
  }

  UpdateProCompany(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/pro/update`, params);
  }

  ReadProAuthority(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/member/authority/mgt`, params);
  }

  ReadProMmemberAuthority(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/member/authority/read`, params);
  }

  UpdateProAuthority(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/member/authority/update`, params);
  }

  DeleteProAuthority(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/region/member/authority/delete`, params);
  }

  triggerEvent(value) {
    this.geteventEmitter.emit(value);
  }

  set SetSelectDefaultMode(value) {
    localStorage.setItem(STORE_KEY_selectDefaultMode, value);
  }

  get GetSelectDefaultMode() {
    const data = localStorage.getItem(STORE_KEY_selectDefaultMode);
    return data || 'Default';
  }

  set SetThemeColorCode(value) {
    localStorage.setItem(STORE_KEY_themeColorCode, value);
  }

  get GetThemeColorCode() {
    const data = localStorage.getItem(STORE_KEY_themeColorCode);
    return data || '#007ad9';
  }

  set SetLogoPath(value) {
    localStorage.setItem(STORE_KEY_logoPath, value);
  }

  get GetLogoPath() {
    const data = localStorage.getItem(STORE_KEY_logoPath);
    return data || '';
  }

  set SetEnableDomain(value) {
    localStorage.setItem(STORE_KEY_enableDomain, value);
  }

  get GetEnableDomain() {
    const data = localStorage.getItem(STORE_KEY_enableDomain) == "0" ? false : true ; 
    return data || false;
  }

  set SetDomainPath(value) {
    localStorage.setItem(STORE_KEY_domainPtah, value);
  }

  get GetDomainPath() {
    const data = localStorage.getItem(STORE_KEY_domainPtah);
    return data || '';
  }

  set SetRegionIds(value) {
    localStorage.setItem(STORE_KEY_RegionIds, value);
  }

  get GetRegionIds() {
    const data = localStorage.getItem(STORE_KEY_RegionIds);
    return data || '';
  }
  
  set SetSelectTab(value) {
    localStorage.setItem(STORE_KEY_SelectTab, value);
  }

  get GetSelectTab() {
    const data = localStorage.getItem(STORE_KEY_SelectTab);
    return data || '0';
  }

  set SetBillingStatement(value) {
    localStorage.setItem(STORE_KEY_BillingStatement, JSON.stringify(value));
  }

  RemoveBillingStatement() {
    localStorage.removeItem(STORE_KEY_BillingStatement);
  }

  get GetBillingStatement() {
    const data = localStorage.getItem(STORE_KEY_BillingStatement);
    return data || '';
  }
}
